import React, { FC, ReactNode, useState } from 'react';
import classNames from 'classnames';

import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

import styles from './CollapsiblePolicyCard.module.scss';

export interface CollapsiblePolicyCardProps {
    title: string;
    children: ReactNode;
    defaultCollapsed?: boolean;
    className?: string;
}

/**
 * Collapsible card component for grouping policy settings
 * Used in the new policy editor interface
 */
const CollapsiblePolicyCard: FC<CollapsiblePolicyCardProps> = ({
    title,
    children,
    defaultCollapsed = false,
    className,
}) => {
    const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

    const toggleCollapse = (): void => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <div className={classNames(styles.card, className)}>
            <button
                type="button"
                className={styles.cardHeader}
                onClick={toggleCollapse}
                aria-expanded={!isCollapsed}
            >
                <h3 className={styles.cardTitle}>{title}</h3>
                <span className={styles.collapseIcon}>
                    {isCollapsed ? <CaretDownOutlined /> : <CaretUpOutlined />}
                </span>
            </button>
            {!isCollapsed && (
                <div className={styles.cardContent}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsiblePolicyCard;
